// Submit explicitly while reusing the theme's native discount request and refresh.
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-mr-cart-discount-form] input[name="code"]')) event.stopPropagation();
}, true);

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-mr-cart-discount-form]');
  if (!form) return;
  event.preventDefault();
  const field = form.querySelector('cart-discount-field');
  const input = form.querySelector('input[name="code"]');
  const button = form.querySelector('button[type="submit"]');
  const banner = form.parentElement.querySelector('cart-discount-banner');
  if (!input.value.trim() || button.disabled) return;
  await customElements.whenDefined('cart-discount-field');
  input.value = input.value.trim();
  banner.hidden = true;
  button.disabled = true;
  button.textContent = 'applying…';
  try {
    await field.toggleDiscount({ currentTarget: field, target: input });
  } catch {
    field.setAttribute('aria-busy', 'false');
    banner.querySelector('p').textContent = 'Unable to apply the code. Please try again.';
    banner.hidden = false;
  } finally {
    button.disabled = false;
    button.textContent = 'apply';
  }
});
